import PropTypes from 'prop-types';
import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { convertTokens } from '@date-fns/upgrade/v2';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

import ProfileIcon from 'assets/icons/profile.svg';
import { blackish, gray } from 'utils/color-styles';
import Img from 'retired/Img';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';
import getDeedPathSlugFromType from 'utils/getDeedPathSlugFromType';
import { DeedListDateInfoWithStatus } from 'components/DeedListDateInfoWithStatus';
import { deedStyles } from 'containers/VolunteerPage/deedStyles';

const Deed = ({ deed }) => (
  <Link style={{ color: blackish }} to={`/deeds/${getDeedPathSlugFromType(deed.type)}/${deed.id}`}>
    <div style={deedStyles}>
      <DeedListDateInfoWithStatus
        date={deed.startingAt}
        timeZone={deed.timeZone}
      ></DeedListDateInfoWithStatus>
      <div style={{ flexGrow: 1, marginLeft: 28 }}>
        <Grid container alignItems="center">
          <Grid item xs style={{ height: '100%', margin: '0 !important' }}>
            <h3
              style={{
                fontSize: 16,
                fontWeight: 500,
                margin: '0px 0px 7px',
              }}
            >
              {deed.name}
            </h3>
            <div style={{ fontSize: 12 }}>
              {[deed.locationObject.area, deed.locationObject.city, deed.locationObject.state]
                .filter(Boolean)
                .join(', ')}
            </div>
            <div style={{ fontSize: 12, fontWeight: 300 }}>
              {formatInTimeZone(deed.startingAt, deed.timeZone, convertTokens('dddd, h:mmA'))}-
              {formatInTimeZone(deed.endingAt, deed.timeZone, convertTokens('h:mmA'))}
            </div>
          </Grid>
          <Grid item xs>
            <h4
              style={{
                fontSize: 15,
                fontWeight: 300,
                marginBottom: 34,
              }}
            />
            <div style={{ fontSize: 11, color: gray }}>
              <div style={{ display: 'inline-block' }}>
                <Img
                  src={ProfileIcon}
                  alt=""
                  style={{
                    width: 12,
                    height: 12,
                    verticalAlign: 'baseline',
                  }}
                />
                <span
                  style={{
                    color: '#ADADC3',
                    marginLeft: 12,
                    marginRight: 12,
                    verticalAlign: 'top',
                  }}
                >
                  {deed.attendees.length}
                  {deed.attendeeLimit > 0 &&
                    deed.attendees.length <= deed.attendeeLimit &&
                    `/${deed.attendeeLimit}`}{' '}
                  Attendees
                </span>
                <span
                  style={{
                    color: '#ADADC3',
                    marginLeft: 12,
                    verticalAlign: 'top',
                  }}
                >
                  {deed.waitlist.length > 0 && `Waitlist: ${deed.waitlist.length}`}
                </span>
              </div>
            </div>
          </Grid>
          <Grid item xs>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                height: 93,
                paddingTop: 5,
                overflow: 'hidden',
                alignItems: 'flex-end',
              }}
            />
          </Grid>
        </Grid>
      </div>
      <div style={{ lineHeight: '100px' }}>
        <Img
          src={ArrowRightIcon}
          alt=""
          style={{
            height: 24,
            verticalAlign: 'middle',
            marginLeft: 38,
            marginRight: 38,
          }}
        />
      </div>
    </div>
  </Link>
);

Deed.propTypes = {
  deed: PropTypes.object.isRequired,
};

export default Deed;
